<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex>
              <div>New Conversation</div>
            </v-flex>
            <v-flex text-right>
              <v-btn icon @click="cancel">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-form ref="form">
          <v-layout class="px-4 mb-3">
            <v-flex>
              <v-layout>
                <v-flex>
                  <div class="subtitle-2 mb-1">
                    What's the Content of the Conversation?
                  </div>
                  <v-textarea
                    rows="3"
                    v-model="content"
                    :rules="rules.textarea"
                    dense
                    outlined
                    required
                    placeholder="Conversation Content"
                    counter
                    maxlength="200"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex class="mr-1" xs6>
                  <div class="subtitle-2 mb-1">Schedule At</div>
                  <v-text-field
                    readonly
                    v-model="scheduledAtDateString"
                    dense
                    :rules="rules.scheduledAt"
                    required
                    outlined
                    placeholder="Scheduled Date"
                    @click="openScheduleDateDialog"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout class="mt-3">
                <div class="subtitle-1 font-weight-medium">Chat Options</div>
              </v-layout>

              <v-layout class="mt-3">
                <v-flex>
                  <div class="subtitle-2 mb-1">Region</div>
                  <v-select
                    outlined
                    dense
                    return-object
                    :rules="[(v) => !!v || 'Item is required']"
                    required
                    hide-details
                    :items="regions"
                    v-model="region"
                    item-text="name"
                    placeholder="Region"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <!-- <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="reviewedEntities"
                v-model="entity"
                item-text="title"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout> -->

              <!-- <v-layout class="mt-3">
                <v-flex xs6 class="mr-1">
                  <div class="subtitle-2 mb-1">Link Name</div>
                  <v-text-field
                    v-model="linkName"
                    hide-details
                    dense
                    outlined
                    placeholder="Link Name"
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 class="ml-1">
                  <div class="subtitle-2 mb-1">Link URL</div>
                  <v-text-field
                    v-model="linkUrl"
                    hide-details
                    dense
                    outlined
                    placeholder="Ex: http://..."
                  ></v-text-field>
                </v-flex>
              </v-layout> -->

              <gallery-image-select-section
                ref="galleryImageSelectSectionRef"
                @imageSelected="galleryImageSelected"
              />
            </v-flex>
          </v-layout>
        </v-form>

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="cancel"
            color="error"
            class="text-none subtitle-2"
            outlined
          >
            Cancel
          </v-btn>
          <v-btn color="primary" class="text-none subtitle-2" @click="save">
            Schedule
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    GalleryImageSelectSection,
  },
  data() {
    return {
      valid: true,
      dialog: false,
      rules: {
        textarea: [(v) => v.length <= 150 || 'Max 150 characters'],
        select: [(v) => !!v || 'Item is required'],
        scheduledAt: [(v) => !!v || 'Scheduled at time is required'],
      },

      loading: false,
      scheduleDateDialog: false,

      scheduledAtDateField: '',

      scheduledAt: '',

      region: {},

      createdBy: '',
      content: '',

      isMarker: false,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      linkUrl: '',
      linkName: '',

      selectedFromGallery: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),

    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },

    changeFields() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'conversation',
        region: this.region,

        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },

        data: {
          content: this.content,
          createdBy: auth.currentUser.uid,

          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude),
          ),
          score: Number(0),
          totalComments: Number(0),
          type: 'conversation',
          views: Number(0),
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });

    // this.getEntityTypes({
    //   collection: "entityTypes",
    //   mutation: "updateEntityTypes",
    // });
    // this.getEntities({
    //   collection: "entities",
    //   condition: {
    //     leftVal: "state",
    //     operator: "==",
    //     rightVal: "reviewed",
    //   },
    //   mutation: "updateReviewedEntities",
    // });
  },
  methods: {
    ...mapActions({
      createNewChat: '$_content/createNewContent',
      uploadImage: '$_content/uploadImage',
      getRegions: '$_home/getContent',
      getChats: '$_content/getContent',
      getChatsByRegion: '$_content/getContentByRegion',
    }),
    validate() {
      this.$refs.form.validate();
    },

    openImageGallery() {
      this.$refs.imageGalleryRef.toggleDialog();
    },

    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },

    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
      this.imageUrl = image.url;
    },
    cancel() {
      this.scheduledAtDateField = '';

      this.scheduledAt = '';

      this.state = '';
      this.region = {};

      this.createdBy = '';
      this.content = '';

      this.isMarker = false;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';

      this.expiryRange = '';
      //   this.linkName = "";
      //   this.linkUrl = "";

      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }
      this.selectedFromGallery = false;

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);

      if (!this.scheduledAtDateString) {
        alert('Yo yo, Slow down dude, add a Scheduled At time');
        return;
      }

      this.createNewChat({
        details: this.changeFields,
        collection: this.collection,
        type: 'Conversation',
      }).then(() => {
        this.cancel();
        if (this.selectedRegion) {
          this.getChatsByRegion({
            type: 'conversation',
            collection: this.collection,
            mutation: 'updateChats',
            region: this.selectedRegion,
          });
        }
      });
    },
  },
};
</script>

<style></style>
